import React, { Component } from 'react';
import { connect } from 'react-redux';
import InlineInput from 'components/util/inlineInput';
import { localeStringActions } from 'actions/api/localeStrings';
import styles from './styles.scss';
import { ClassicButton } from 'components/util/buttons';
import LodIcon from 'components/util/lodIcon';
import Tooltip from 'components/util/tooltip';
import classnames from 'classnames';
import InterpolateHightlighter from 'components/dashboard/partnerDashboard/interpolateHighlighter';
import { openCustomModal } from 'actions/modals';

const ImagePreviewModal = ({ string }) => (
  <div>
    <img
      alt="preview"
      style={{ width: '100%' }}
      src={string.base_string.image_url}
    />
  </div>
);

class UnverifiedRow extends Component {
  constructor(props) {
    super(props);
    const { string } = props;
    this.state = {
      translation: string.google_translation
    };
  }

  onChange = (val = '') => {
    this.setState({ translation: val });
  };

  onBlur = () => {
    const { string } = this.props;
    if (!this.state.translation) {
      this.setState({ translation: string.google_translation });
    }
  };

  onReturn = () => {
    this.onSave();
  };

  openImageModal = string => {
    this.props.dispatch(
      openCustomModal({
        size: 'sm',
        component: ImagePreviewModal,
        string: string
      })
    );
  };

  onSave = async () => {
    if (this.state.translation) {
      await this.props.dispatch(
        localeStringActions.save({
          data: {
            id: this.props.string.id,
            partner_translation: this.state.translation
          },
          background: true
        })
      );
      this.props.searchStrings({ background: true });
    }
  };

  render() {
    const { string, classifications } = this.props;

    const isSystem =
      !string.base_string.element_classification_id &&
      string.base_string.system_classification_id;

    return (
      <tr
        key={string.id}
        className={classnames(styles.wrapper, {
          [styles.system]: isSystem
        })}>
        {classifications && (
          <td>
            {string.base_string.image_url && (
              <img
                onClick={() => this.openImageModal(string)}
                className={styles.imagePreview}
                alt="img_url"
                src={string.base_string.image_url}
              />
            )}
          </td>
        )}

        <td className={styles.englishCol}>
          {!!string.base_string.description && !classifications && (
            <Tooltip text={string.base_string.description}>
              <span className={styles.descriptionIcon}>
                <LodIcon icon="infoCircle" />
              </span>
            </Tooltip>
          )}
          <InterpolateHightlighter
            interpolators={string.base_string.interpolators}
            value={string.base_string.value}
          />
        </td>
        <td>
          <InlineInput
            value={this.state.translation}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onReturn={this.onReturn}
            staticLine
          />
        </td>
        <td className={styles.btnCol}>
          <ClassicButton label="Verify" onClick={this.onSave} />
        </td>
      </tr>
    );
  }
}

export default connect()(UnverifiedRow);



// WEBPACK FOOTER //
// ./src/components/dashboard/partnerDashboard/unverifiedRow/index.js